import ImageHead from '@/assets/images/hydra_score_head_sm.webp'
import { siteConfig } from '@/config/site'
import { ReactNode } from 'react'

interface SignInFormContainerProps {
  children: ReactNode
  title: string
}

export default function SignInFormContainer({
  children,
  title,
}: SignInFormContainerProps) {
  return (
    <div className="flex justify-center flex-wrap items-center px-6 py-12 max-w-2xl mx-auto bg-white rounded">
      <div className="w-full md:w-[87%] lg:w-[72%]">
        <div
          className="items-center w-full flex flex-col"
          style={{ padding: '1em 1em' }}
        >
          <a href={siteConfig.landingUrl}>
            <img src={ImageHead} alt="Head" />
          </a>
          <h1 className="text-3xl text-center mt-4 mb-0 font-semibold">{title}</h1>
        </div>
        {children}
      </div>
    </div>
  )
}
